module.exports = __webpack_public_path__ + "media/images/responsive/costumes/category_icons/dress/princess-484b41fadc98c2b26dad3086bc19770e.jpg";